module.exports = __webpack_public_path__ + "static/img/Geos-2022-Derly.2a6f83c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Geos-2022-Derly.png
// module id = 3umg
// module chunks = 0